<template>
  <div class="distributor-record-statis">
    <div class="common-header-wrap">
      <mt-header title="业绩统计" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="echarts-list">
      <e-charts :style="getStyle" :options="bar1" />
      <e-charts :style="getStyle" :options="bar2" />
      <e-charts :style="getStyle" :options="pie" />
    </div>
  </div>
</template>

<script>

import { Toast } from 'mint-ui'
import { mapState } from 'vuex'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title'

export default {
  components: {
    ECharts
  },
  name: 'DistributorRecordStatis',
  data () {
    return {
      pie: {
        title: {
          text: '周订单来源',
          x: 'center'
        },

        series: [
          {
            name: '订单来源',
            type: 'pie',
            data: [
              {value: 335, name: '系统派单'},
              {value: 310, name: '店铺派单'},
              {value: 234, name: '自己抢单'}

            ]

          }
        ]
      },
      bar1: {
        title: {
          text: '周订单完成量',
          x: 'center'
        },
        color: ['#FF9900'],
        xAxis: {
          type: 'category',
          data: ['1.12', '1.13', '1.14', '1.15', '1.16', '1.19', '1.20']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'bar'
        }]
      },
      bar2: {
        title: {
          text: '周订单完成用时',
          x: 'center'
        },
        color: ['#339933'],
        xAxis: {
          type: 'category',
          data: ['1.12', '1.13', '1.14', '1.15', '1.16', '1.19', '1.20']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'bar'
        }]
      }
    }
  },
  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  computed: {
    getStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      // let itemHeight = width * (94.0 / 188.0)
      return {
        width: itemWidth + 'px',
        height: itemWidth / 4 * 3 + 'px'
      }
    },
    ...mapState({
      user: state => state.distributor.info
    })
  },
  created: function () {

  },

  methods: {

  }
}
</script>
<style  lang="scss" scoped>
  .distributor-record-statis {
    .echarts-list {
      padding-top: 2rem;
    }
  }
</style>
